import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
import {langRegister} from "../../services/langRegister";
import {salesChannelRegister} from "../../services/salesChannelRegister";
import {dataRegister} from "../../services/dataRegister";
import queryString from "query-string";

class SignupAdsBing extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selected: false,
            learn_more: false,
            quotes: null,
            market: null,
            website: null,
            tips: [],
            industry: {},
            customIndustry: null,
            available: false
        };
    };

    componentDidMount() {
        this._updateData();
    }

    _updateData() {
        this.setState({
            tips: [
                {title: this._renderText("item_48")},
                {title: this._renderText("item_49")},
                {title: this._renderText("item_50")},
                {title: this._renderText("item_51")},
                {title: this._renderText("item_52")},
                {title: this._renderText("item_53")}
            ],
            selected: this.props.setChannel,
            quotes: this.props.setQuotes,
            industry: this.props.setIndustry,
            customIndustry: this.props.setCustomIndustry,
            website: this.props.setWebsite,
            market: salesChannelRegister.get('market'),
            available: this.props.setAvailable
        });
    }

    _placement(){
        try{
            let query = {
                industry: this.state.customIndustry?this.state.customIndustry:this.state.industry.name,
                region: salesChannelRegister.get("market"),
                quotes: this._renderQuotes(),
                website: this.state.website?this.state.website:(this._renderText("item_60") + salesChannelRegister.get("market"))
            };
            const stringified = queryString.stringify(query);
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/bing?" + stringified, '_blank');
        }catch (e) {
            window.open('https://placement.'+dataRegister.domain+"/"+langRegister.lang()+"/bing", '_blank');
        }
    }

    _renderQuotes() {
        if (this.state.quotes) {
            let quotes_string = "";
            if (!this.state.quotes.custom) {
                let i = 1;
                var sortable = [];
                for (var key in this.state.quotes) {
                    sortable.push([this.state.quotes[key], this.state.quotes[key].index]);
                }
                sortable.sort(function(a, b) {
                    return a[1] - b[1];
                });
                sortable.map((item) => {
                    quotes_string += item[0].slogan + (sortable.length > i ? " - " : "");
                    i++;
                });
            } else {
                quotes_string = this.state.quotes.text;
            }
            console.log(quotes_string);
            return quotes_string
        }
    }

    _renderIndustry(){
        if(this.state.customIndustry){
            return this.state.customIndustry;
        }else{
            return this.state.industry.name;
        }
    }

    _renderText(item) {
        return langRegister.get("signup-ads", item);
    }

    render() {
        return (
            <div className={Styles.contentContainerLeftItem}>
                {
                    this.state.selected && this.state.available &&
                    <div onClick={() => this._placement()} className={Styles.contentContainerLeftItemPlacement}>
                        <img src={require("../../assets/images/plus_sign_white_small.png")} className={Styles.contentContainerLeftItemPlacementIcon}/>
                    </div>
                }
                <div onMouseDown={() => {
                    if (this.state.selected) {
                        this.props.removeChannel("bing"); this.setState({selected: false})
                    }
                }} className={
                    cx(Styles.contentContainerLeftItemInner,
                        {
                            [Styles.contentContainerLeftItemInnerActive]: !this.state.selected,
                        })
                }
                >
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemInnerOverlay,
                                {
                                    [Styles.contentContainerLeftItemInnerOverlayActive]: !this.state.selected,
                                })
                        }
                    >
                        {
                            !this.state.selected &&
                            <div onClick={() => {
                                if(this.state.available){
                                    this.props.selectChannel("bing"); this.setState({selected: !this.state.selected})
                                }
                            }}
                                 className={
                                     cx(Styles.contentContainerLeftItemInnerOverlayButton,
                                         {
                                             [Styles.contentContainerLeftItemInnerOverlayButtonDisabled]: !this.state.available,
                                         })
                                 }>
                                {
                                    this.state.available &&
                                    this._renderText("item_18")
                                }
                                {
                                    !this.state.available &&
                                    this._renderText("item_65")
                                }
                            </div>
                        }
                        <div className={Styles.contentContainerLeftItemInnerOverlayTitle}>
                            Bing <span className={Styles.contentContainerLeftItemInnerOverlayTitleSmall}>search ads</span>
                        </div>
                        {
                            this.state.tips.filter((item, key) => {
                                return !this.state.learn_more && key < 3 || this.state.learn_more && key > 2
                            }).map((prop, i) => {
                                return (
                                    <div key={i}
                                         className={Styles.contentContainerLeftItemInnerOverlayItem}>
                                        &#x2b; {prop.title}
                                    </div>
                                )
                            })
                        }
                        <div onClick={() => this.setState({learn_more: !this.state.learn_more})} className={Styles.contentContainerLeftItemInnerOverlayReadMore}>
                            {
                                this.state.learn_more &&
                                <span>{this._renderText("item_28")}</span>
                            }
                            {
                                !this.state.learn_more &&
                                <span>{this._renderText("item_29")}</span>
                            }
                        </div>
                    </div>
                    <div className={Styles.contentContainerLeftItemGoogleTop}>
                        <div className={Styles.contentContainerLeftItemGoogleTopLeft}/>
                        <div className={Styles.contentContainerLeftItemGoogleTopRight}/>
                    </div>
                    <div className={Styles.contentContainerLeftItemGoogleAd}>
                        <div className={Styles.contentContainerLeftItemGoogleAdTitle}>
                            {this._renderIndustry()}
                        </div>
                        <div className={Styles.contentContainerLeftItemGoogleAdUrlContainer}>
                            <div className={Styles.contentContainerLeftItemGoogleAdIconContainer}>
                                {this._renderText("item_62")}
                            </div>
                            {
                                !this.state.website &&
                                <div
                                    className={Styles.contentContainerLeftItemGoogleAdUrlContainerLink}>
                                    {this._renderText("item_60")}{this.state.market}
                                </div>
                            }
                            {
                                this.state.website &&
                                <div className={Styles.contentContainerLeftItemGoogleAdUrlContainerLink}>
                                    {this.state.website}
                                </div>
                            }
                        </div>
                        <div className={Styles.contentContainerLeftItemGoogleAdDivider}/>
                        <div className={Styles.contentContainerLeftItemGoogleAdText}>
                            {this._renderQuotes()}
                        </div>
                    </div>
                    <img className={Styles.contentContainerLeftItemGoogleAdContent}
                         src={require("../../assets/images/google_text.svg")}/>
                </div>
                <div className={Styles.contentContainerLeftItemBottom}>
                    <div
                        className={
                            cx(Styles.contentContainerLeftItemBottomIconContainer,
                                {
                                    [Styles.contentContainerLeftItemBottomIconContainerActive]: this.state.selected,
                                })
                        }
                    >
                        <img className={Styles.contentContainerLeftItemBottomIconContainerIcon}
                             src={require("../../assets/images/bing_logo_icon.svg")}/>
                    </div>
                    {
                        !this.state.selected && this.state.available &&
                        <img onClick={() => {this.props.selectChannel("bing"); this.setState({selected: !this.state.selected})}}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_deactive.svg")}/>
                    }
                    {
                        this.state.selected && this.state.available &&
                        <img onClick={() => {this.props.selectChannel("bing"); this.setState({selected: !this.state.selected})}}
                             className={Styles.contentContainerLeftItemBottomSlider}
                             src={require("../../assets/images/slider_active.svg")}/>
                    }
                    {
                        !this.state.selected &&
                        <div className={Styles.contentContainerLeftItemBottomDots}>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: !this.state.learn_more,
                                    })
                            }/>
                            <div className={Styles.contentContainerLeftItemBottomDotsItemLine}/>
                            <div className={
                                cx(Styles.contentContainerLeftItemBottomDotsItem,
                                    {
                                        [Styles.contentContainerLeftItemBottomDotsItemActive]: this.state.learn_more,
                                    })
                            }/>
                        </div>
                    }
                </div>
            </div>
        );
    }
}

export default SignupAdsBing;


// WEBPACK FOOTER //
// ./src/components/signup-ads-bing/component.js